import { Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function G() {
    const { useLang, Link, useRouter } = useGlobal();
    const { t } = useLang('powerindependence');
    const { locale } = useRouter();

    const cards: any = [
        {
            img: '/responsive/picture/power-independence/7_1',
            tag: t('secG_tag1'),
        },
        {
            img: '/responsive/picture/power-independence/7_2',
            tag: t('secG_tag2'),
        },
        {
            img: '/responsive/picture/power-independence/7_3',
            tag: t('secG_tag3'),
        },
        {
            img: '/responsive/picture/power-independence/7_4',
            tag: t('secG_tag4'),
        },
    ];

    const lists: any = [
        {
            title: t('secG_list1_title'),
            desc: t('secG_list1_desc'),
        },
        {
            title: t('secG_list2_title'),
            desc: t('secG_list2_desc'),
        },
        {
            title: t('secG_list3_title'),
            desc: t('secG_list3_desc'),
        },
        {
            title: t('secG_list4_title'),
            desc: t('secG_list4_desc'),
        },
    ];

    if (locale === 'fr') {
        lists.push({
            title: t('secG_list5_title'),
            desc: t('secG_list5_desc'),
        });
    }

    return (
        <div id="power-independence-G" className={`power-independence-G ${css['power-independence-G']}`}>
            <div className="ef-box">
                <div className="box">
                    <Swiper
                        className="cards swiper-box"
                        effect="fade"
                        modules={[Pagination, Autoplay]}
                        spaceBetween={0}
                        pagination={true}
                        slidesPerView={'auto'}
                        initialSlide={0}
                        loop={true}
                        autoplay={{
                            delay: 4000,
                            disableOnInteraction: false,
                        }}
                    >
                        {cards?.map((card: any, k: number) => (
                            <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                                <EFPicture src={`${card?.img}.jpg`} srcPad={`${card?.img}_375.jpg`} srcMobile={`${card?.img}_375.jpg`} alt={card?.tag} />
                                <span className="card-tag">{card?.tag}</span>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <div className="card-info">
                        <p className="card-title">{t('secG_title')}</p>
                        <p className="card-desc">{t('secG_desc')}</p>
                        <ul className="card-lists">
                            {lists?.map((list: any) => (
                                <li className="card-list" key={list?.title}>
                                    <p className="list-title">{list?.title}</p>
                                    <p className="list-desc">{list?.desc}</p>
                                </li>
                            ))}
                        </ul>
                        <div className="card-btns">
                            <Link
                                className="btn-buy card-btn"
                                href={`https://${locale}.ecoflow.com/pages/powerstream?utm_source=scenario+page&utm_medium=Pillar`}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'buy',
                                    product_name: t('secG_title').replace('\n', ' '),
                                    position: 'Product PreLaunch',
                                }}
                            >
                                {t('common_card_buy')}
                            </Link>
                            <Link
                                className="btn-more card-btn"
                                href="/powerstream?utm_source=scenario+page&utm_medium=Pillar"
                                target="_blank"
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'select_product',
                                    list_name: t('secG_title').replace('\n', ' '),
                                    product_name: t('secG_title').replace('\n', ' '),
                                    button_name: t('common_card_more'),
                                }}
                            >
                                {t('common_card_more')}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
